import React, { Component } from "react";

class GetHelp extends Component {
    render() {
        return (
            <div>
                <h1 style={{fontWeight: 500, margin: 0, paddingBottom: 10}}>Get Help</h1>

                <div className="content">

                </div>
            </div>
        );
    }
}

export default GetHelp;